import { useState, useEffect } from "react";

export default function usePagination(initialLimit = 10) {
    const [rows, setRows] = useState(0);
    const [limit, setLimit] = useState(initialLimit);
    const [page, setPage] = useState({
        current: 0,
        total: 1,
        previous: false,
        next: false,
    });

    function updatePosition() {
        page.next = page.current < page.total - 1;
        page.previous = page.current > 0;
    }

    function setTotalRows(totalRows) {
        setRows(totalRows);
    }

    function changeLimit(newLimit) {
        setLimit(newLimit);
    }

    function changePage(step) {
        const newPage = page.current + step;
        if (newPage < 0 || newPage > page.total - 1) return;
        page.current = newPage;
        updatePosition();
        setPage({ ...page });
    }

    function getIndex(index) {
        const startIndex = limit * page.current + index;
        return startIndex;
        //return startIndex < 10 ? `0${startIndex}` : `${startIndex}`;
    }

    useEffect(() => {
        page.total = Math.ceil(rows / limit);
        updatePosition();
        setPage({ ...page });
    }, [limit, rows]);

    return {
        limit,
        page,
        setTotalRows,
        changePage,
        changeLimit,
        getIndex,
    };
}
